export const checkLogin = (isLoggedIn: boolean, callback: () => void): void => {
    if (isLoggedIn) {
        callback();
    } else {
        location.href = `/signin?onLogin=${encodeURIComponent(location.href)}`;
    }
};
